import { render, staticRenderFns } from "./Weight.vue?vue&type=template&id=371f76ce&scoped=true&"
import script from "./Weight.vue?vue&type=script&lang=js&"
export * from "./Weight.vue?vue&type=script&lang=js&"
import style0 from "./Weight.vue?vue&type=style&index=0&id=371f76ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f76ce",
  null
  
)

export default component.exports